import { WalletTransferDirection } from '../types/topups.types';
import { PlatformFinanceCategory } from '../types/platform-finance.types';

export interface PlatformFinanceCategoryDefinition {
  id: PlatformFinanceCategory;
  flow: WalletTransferDirection.IN | WalletTransferDirection.OUT;
  label: string;
  description: string;
  sort_order: number;
}

/** Categories for platform finance classifications (static; no table). */
export const PLATFORM_FINANCE_CATEGORIES: PlatformFinanceCategoryDefinition[] =
  [
    {
      id: PlatformFinanceCategory.INC_SUBSCRIPTION,
      flow: WalletTransferDirection.IN,
      label: 'Subscription',
      description: 'Pays the store invoices',
      sort_order: 10,
    },
    {
      id: PlatformFinanceCategory.INC_TOPUP,
      flow: WalletTransferDirection.IN,
      label: 'Wallet top-up',
      description: 'Credited to the merchant/store wallet',
      sort_order: 20,
    },
    {
      id: PlatformFinanceCategory.INC_MATERIAL,
      flow: WalletTransferDirection.IN,
      label: 'Materials payment',
      description: 'Client payment for purchased materials',
      sort_order: 30,
    },
    {
      id: PlatformFinanceCategory.INC_OTHER,
      flow: WalletTransferDirection.IN,
      label: 'Other income',
      description: 'Donation, investment or any other money in',
      sort_order: 90,
    },
    {
      id: PlatformFinanceCategory.EXP_TRANSPORT,
      flow: WalletTransferDirection.OUT,
      label: 'Transport',
      description: 'Agent/client transport costs',
      sort_order: 10,
    },
    {
      id: PlatformFinanceCategory.EXP_INTERNET,
      flow: WalletTransferDirection.OUT,
      label: 'Internet',
      description: 'Internet/data costs',
      sort_order: 20,
    },
    {
      id: PlatformFinanceCategory.EXP_MATERIAL,
      flow: WalletTransferDirection.OUT,
      label: 'Material purchase',
      description: 'Equipment/material purchase',
      sort_order: 30,
    },
    {
      id: PlatformFinanceCategory.EXP_SALARY,
      flow: WalletTransferDirection.OUT,
      label: 'Salary',
      description: 'Agent salary/wages',
      sort_order: 40,
    },
    {
      id: PlatformFinanceCategory.EXP_AI,
      flow: WalletTransferDirection.OUT,
      label: 'AI tools',
      description: 'Claude, ChatGPT, DeepSeek and other AI plans or credits',
      sort_order: 50,
    },
    {
      id: PlatformFinanceCategory.EXP_CLOUD,
      flow: WalletTransferDirection.OUT,
      label: 'Cloud hosting',
      description: 'AWS and other hosting bills',
      sort_order: 60,
    },
    {
      id: PlatformFinanceCategory.EXP_DEV_TOOLS,
      flow: WalletTransferDirection.OUT,
      label: 'Dev tools',
      description: 'GitHub and other software tools',
      sort_order: 70,
    },
    {
      id: PlatformFinanceCategory.EXP_FOUNDER_REIMBURSEMENT,
      flow: WalletTransferDirection.OUT,
      label: 'Founder reimbursement',
      description: 'Pays a founder back for costs they paid personally',
      sort_order: 80,
    },
    {
      id: PlatformFinanceCategory.EXP_OTHER,
      flow: WalletTransferDirection.OUT,
      label: 'Other expense',
      description: 'Any other outgoing cost',
      sort_order: 90,
    },
  ];

/** Wallet reference types used by platform finance postings. */
export const PLATFORM_FINANCE_REFERENCE_TYPES = {
  /** Platform wallet debit for an expense split (reference_id = tx id#split id). */
  EXPENSE: 'platform_finance_expense',
  /** Platform wallet credit reversing an expense split. */
  EXPENSE_REVERSAL: 'platform_finance_expense_reversal',
} as const;
